import { createFileRoute } from '@tanstack/react-router'
import { EmailUnsubscribePage } from '../components/email-pages'
import { noIndexRouteHead } from '../lib/seo'

export const Route = createFileRoute('/fr/desabonnement')({
  head: () => noIndexRouteHead('emailUnsubscribe', 'fr'),
  component: EmailUnsubscribePage,
})
